import { RouterManager } from '@aclass/admin/managers';
import { EmailPipelineStory } from '@aclass/admin/storage/actions';
import { IAdminState, IEmailPipelineModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class EmailPipelineSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:email-pipeline-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IEmailPipelineModuleState['searchPageInitialized']>(['emailPipelineModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(EmailPipelineSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(EmailPipelineStory.dryRunSearchPage());
    }
}
